import { IAnalyticsUser } from '../../types/analytics';
import { IApplicationState } from '../../types/redux';

export function selectUser(state: IApplicationState): IAnalyticsUser {
  const { user } = state;

  return user.isAuthenticated
    ? {
        userId: user.userId,
        cianUserId: user.id,
      }
    : {};
}
